
export default {
    methods: {
        getDecodeFromBase64ToHtml(str) {
            return Buffer.from(str, 'base64').toString('utf-8')
        }

    }
}